/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerTrafficQuery($customerId: ID!, $endDate: DateTime!, $startDate: DateTime!) {
  CustomerTraffic(customerId: $customerId, endDate: $endDate, startDate: $startDate) {
    id,
    status,
    message,
    _report
  }
}
`
